import Templater from "./templater";
import logger from "./logger";

export class HtmlTemplates {
	static searchGamesSuggestion = 'rootjs_search_games_suggestion';
	static searchGamesResult = 'rootjs_search_games_result';
	static emailNotification = 'rootjs_email_notification';
	static notification = 'rootjs_notification';
	static luckyShot = 'rootjs_lucky_shot';

	static loaderHTML = 'rootjs_loader_html';
	static loaderStyle = 'rootjs_loader_style';

	static loginSublinks = 'rootjs_login_sublinks';
	static loginSublinksFunMode = 'rootjs_login_sublinks_fun';
	static loginModal = 'rootjs_login_modal';

	static templateLoaded = false;
	static templates = {};

	static async getTemplate(template, rendered = false) {
		if (!this.templateLoaded) {
			let templates = await this.loadTemplates();
			this.templateLoaded = true;
			for (let tpl in templates) {
				this.templates[tpl] = templates[tpl];
			}
		}
		if (!rendered) {
			return this.templates[template];
		} else {
			return this.render(this.templates[template]);
		}
	}

	static async loadTemplates() {
		return (new Templater()).getTemplates();
	}

	static render(templateSting) {
		return new Function(`return \`${templateSting}\`;`)();
	}

}